import React, { useState } from "react";
import { Box, Dialog, DialogContent, Grid, Typography } from "@mui/material";
import { CustomDialogTitle } from "../Styled Components/CustomDialogTitle";
import { StyledGoldButton } from "../Styled Components/Buttons";

const LinkShareDialog = (props) => {
    const { open, toggleDialog, urlToShare } = props;

    const [copied, setCopied] = useState(false);

    const copyToClipboard = (type) => {
        if (/*@cc_on!@*/ false || !!document.documentMode) {
            //Internet explorer has unique method
            window.clipboardData.setData("Text", urlToShare);
        } else {
            navigator.clipboard.writeText(urlToShare);
        }

        setCopied(type);
    };

    const handleCopyClick = () => {
        copyToClipboard("url");
    };

    return (
        <Dialog
            open={open}
            onBackdropClick={toggleDialog}
            maxWidth="md"
            fullWidth={true}
            // onBackdropClick={toggleDialog}
        >
            <CustomDialogTitle onClose={toggleDialog}>
                Refer a Friend with Your Personalized Link
            </CustomDialogTitle>
            <DialogContent>
                <Grid
                    container
                    direction="row"
                    justifyContent="center"
                    spacing={2}
                    sx={{ padding: 1 }}
                >
                    <Grid item>
                        <Typography variant="body1">
                            Your custom referral link is shown below. Copy the
                            link to share with your friends. You'll get credit
                            when they sign up with your link.
                        </Typography>
                        <Box m={0.5} />
                    </Grid>
                    <div
                        style={{
                            backgroundColor: "white",
                            padding: 10,
                            border: "1px solid #ccc",
                            borderRadius: 10,
                        }}
                    >
                        <Grid item container spacing={2} alignItems="center">
                            <Grid item xs container alignItems="center">
                                <Typography
                                    variant="body1"
                                    sx={{
                                        wordBreak: "break-all",
                                        fontSize: "0.70rem"
                                        // [theme.breakpoints.down("lg")]: {
                                        //     fontSize: ".75rem",
                                        // },
                                    }}
                                >
                                    {urlToShare}
                                </Typography>
                            </Grid>
                            <Grid item>
                                <StyledGoldButton
                                    // variant="contained"
                                    size="small"
                                    onClick={handleCopyClick}
                                >
                                    {/* copied === "url" ? 
                                <FontAwesomeIcon icon={faCheck} />
                            :
                                <FontAwesomeIcon icon={['far', 'copy']} />
                            */}
                                    {copied === "url" ? "Copied" : "Copy"}
                                </StyledGoldButton>
                            </Grid>
                        </Grid>
                    </div>
                </Grid>
            </DialogContent>
        </Dialog>
    );
};

export default LinkShareDialog;
